<template lang="pug">
	//- Файлы, добавленные для отправки (zip архивы уже распакованы, из html извлечены base64 ассеты), сгруппированные по типам
	.ai-chat-pending-attachments
		.ai-chat-pending-attachments-header
			i.fa.fa-spinner.fa-spin(v-if="preparing || uploading")
			span {{getDescription()}}
			i.fa.fa-times.ai-chat-pending-attachments-clear(v-if="!uploading" v-on:click="$emit('clear')" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Remove all files'}")
		.ai-chat-attachments-group(v-for="item in groups" :key="item.group.codename")
			.ai-chat-attachments-group-title
				i.fa(:class="item.group.icon")
				span {{item.group.title}} ({{item.files.length}})
			.ai-chat-attachments-files
				//- Набор Spine (json + atlas + png) - одна миниатюра с проигрываемой анимацией, удаляется целиком.
				//- Миниатюры вложений можно перетащить во фрейм превью: ассеты будут созданы автоматически (см. PreviewFrameDrop.vue)
				.ai-chat-attachment.spine(v-for="entry in item.files" v-if="entry.spineFiles" :key="'spine-' + entry.spineKey" draggable="true" v-on:dragstart="startFrameDropFilesDrag($event, createFrameDropFiles(entry.spineFiles))" v-on:dragend="finishFrameDropDrag()" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: getSpineTooltip(entry)}")
					.ai-chat-attachment-preview
						SpinePlayer(:json="entry.spineFiles.json.spineJson" :atlas="entry.spineFiles.atlas.spineAtlas" :imageUrl="entry.spineFiles.png.previewUrl" :width="62" :height="48")
					.ai-chat-attachment-name {{entry.name}}
					i.fa.fa-times-circle.ai-chat-attachment-remove(v-if="!uploading" v-on:click="removeSpineSet(entry)")
				.ai-chat-attachment(v-for="entry in item.files" v-if="!entry.spineFiles" :key="entry.id" :draggable="!!entry.blob" v-on:dragstart="startFrameDropFilesDrag($event, createFrameDropFiles([entry]))" v-on:dragend="finishFrameDropDrag()" :class="{unsupported: !isSupported(item.group)}" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: getTooltip(entry, item.group)}")
					.ai-chat-attachment-preview
						img(v-if="item.group.codename === 'image' && entry.previewUrl" :src="entry.previewUrl" :alt="entry.name")
						video(v-else-if="item.group.codename === 'video' && entry.previewUrl" :src="entry.previewUrl" muted preload="metadata")
						i.fa(v-else :class="item.group.icon")
					.ai-chat-attachment-name {{entry.name}}
					i.fa.fa-times-circle.ai-chat-attachment-remove(v-if="!uploading" v-on:click="$emit('remove', entry)")
		//- Файлы, которые нельзя отправить (пустые, повреждённые архивы, html без base64 ассетов) - агент получит их список
		.ai-chat-pending-attachments-skipped(v-if="skipped.length")
			.ai-chat-pending-attachments-skipped-item(v-for="(item, index) in skipped" :key="index")
				i.fa.fa-ban
				span {{item.name}} - {{item.reason}}
</template>

<script>
	import { AIAgent } 			from './../../services/AIAgent'

	import SpinePlayer 		from './../Dashboard/SpinePlayer'

	import { FrameDropThumbnails }	from './../Dashboard/PreviewFrameDrop'

	export default {
		name: "AIAgentPendingAttachments",
		mixins: [FrameDropThumbnails],
		components: {
			SpinePlayer
		},
		// entries - разобранные файлы, skipped - файлы, которые нельзя отправить, preparing - идёт разбор файлов, uploading - идёт отправка ({done, total} или null)
		props: ['entries', 'skipped', 'preparing', 'uploading'],
		computed: {
			// Добавленные для отправки файлы, сгруппированные по типам (файлы наборов Spine - одним элементом в группе Spine)
			groups() {

				let spineKeys = AIAgent.getPendingSpineKeys(this.entries);

				return AIAgent.groupAttachments(this.entries, entry => entry.ext, entry => spineKeys[entry.id]);

			}
		},
		methods: {
			getDescription() {

				if (this.preparing) return 'Reading files...';
				if (this.uploading) return `Uploading files ${this.uploading.done} of ${this.uploading.total}...`;

				let count = this.entries.length,
					skippedCount = this.skipped.length;

				return _.compact([
					`${count} file${count === 1 ? '' : 's'} to send (${AIAgent.formatAttachmentSize(_.sumBy(this.entries, 'size'))})`,
					skippedCount ? `${skippedCount} can't be read` : null
				]).join(' · ');

			},
			// Файл известного формата, который можно использовать как ассет (окончательно формат проверяет сервер по содержимому)
			isSupported(group) {

				return _.some(AIAgent.getAttachmentFormatGroups(), {codename: group.codename});

			},
			getSpineTooltip(spineSet) {

				return _.map(['json', 'atlas', 'png'], part => spineSet.spineFiles[part].path || spineSet.spineFiles[part].name).join(' + ') + ' · ' + AIAgent.formatAttachmentSize(spineSet.size);

			},
			removeSpineSet(spineSet) {

				_.each(spineSet.spineFiles, entry => this.$emit('remove', entry));

			},
			getTooltip(entry, group) {

				return _.compact([
					entry.path || entry.name,
					AIAgent.formatAttachmentSize(entry.size),
					this.isSupported(group) ? null : `This format can't be used as an asset in this creative`
				]).join(' · ');

			}
		}
	}
</script>

<style lang="sass">

	.ai-chat
		.ai-chat-input
			// Файлы, добавленные для отправки
			.ai-chat-pending-attachments
				max-height: 160px
				margin-top: 6px
				padding: 6px 10px 8px
				overflow-y: auto
				font-size: 12px
				background-color: #2c3237
				border: 1px solid #23282c
				border-radius: 0.25rem

				.ai-chat-pending-attachments-header
					display: flex
					align-items: center
					gap: 6px
					color: #adb6bf

					.ai-chat-pending-attachments-clear
						margin-left: auto
						padding: 3px
						cursor: pointer
						color: #73818f

						&:hover
							color: #f86c6b

				.ai-chat-pending-attachments-skipped
					margin-top: 6px
					color: #f86c6b

					i.fa
						margin-right: 6px

</style>
